export default __webpack_public_path__ + "static/media/dhia.0edcae70.png";